import React, { useEffect } from "react";
import "./index.css";
import {
  ArrowBackIcon,
  BedIcon,
  EmailIcon,
  LocationIcon,
  NextIcon,
  PhoneIcon,
  PreviousIcon,
  ShareIcon,
  ShowerIcon,
  WhatsappIcon,
} from "../../components/icons";
import Area from "../../images/measure.png";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { useGetClassifiedQuery, useViewImpressionClassifiedMutation } from "../../features/supabase/usecase/classifieds";
import storageService from "../../app/services/storageService";
import { RWebShare } from "react-web-share";
import { ListingTile } from "../../components";

const ListingDetailPage = () => {
  const params = useParams();
  const {
    data: classified,
    error,
    isLoading,
  } = useGetClassifiedQuery(parseInt(params.id));


  const [viewImpressionClassified] = useViewImpressionClassifiedMutation();



  console.log(classified);

  const images = [
    "https://cdn.pixabay.com/photo/2015/04/23/22/00/tree-736885_1280.jpg",
    "https://images.pexels.com/photos/268533/pexels-photo-268533.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
  ];

  const navigate = useNavigate();

  const handleBack = () => {
    // pop the current page from the stack
    navigate(-1);
  };

  useEffect(() => {
    console.log(classified);
  }, [classified]);

  const formatPhoneNumber = (phoneNumberString) => {
    const cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return '(' + match[1] + ') ' + match[2] + ' ' + match[3];
    }
    return phoneNumberString;
  };

  if (isLoading) {
    return (
      <section className="loader-section">
        <span className="loader"> </span>
      </section>
    );
  }

  if (classified.status === "deleted") {
    return (
      <div className="listing-detail-container">
        <div className="back-button" onClick={handleBack}>
          <ArrowBackIcon size={19} fill={"black"} />
          <div>Back</div>
        </div>
        <div className="listing-header">
          <div>
            <div className="listing-detail-title">Listing deleted. Kindly contact admin.</div>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className="listing-detail-container">
      <div className="back-button" onClick={handleBack}>
        <ArrowBackIcon size={19} fill={"black"} />
        <div>Back</div>
      </div>

      <div className="listing-header">
        <div>
          <div className="listing-detail-title">{classified?.title ?? ""}</div>
          <div className="listing-detail-subtitle">
            Posted Online {new Date(classified.created_at).toDateString()}
          </div>
        </div>
      </div>
      {classified?.properties?.images.length > 0 && (
        <Carousel width={"100%"} showThumbs={false} renderArrowPrev={(onClick, hasPrev) => {
          return (
            <div className="listing-carousel-arrow left">
              <button className="listing-carousel-button" disabled={
                !hasPrev
              } onClick={onClick}>
                <ArrowBackIcon size={19} fill={"black"} />
              </button>
            </div>
          );
        }}
          renderArrowNext={(onClick, hasNext) => {
            return (
              <div className="listing-carousel-arrow right">
                <button className="listing-carousel-button" disabled={
                  !hasNext
                } onClick={onClick}>
                  <ArrowBackIcon size={19} fill={"black"} style={{
                    transform: "rotate(180deg)"
                  }} />
                </button>
              </div>
            );
          }}
          showStatus={false}
          infiniteLoop

          autoPlay>
          {classified.properties.images.map((image, i) => {
            return (
              <div key={i}>
                <img
                  src={`${storageService.publicUrl(image)}`}
                  alt="listing"
                  className="listing-header-image"
                />
              </div>
            );
          })}
        </Carousel>
      )}
      {classified.category_id !== 5 && <div className="listing-features-section">
        {(classified.properties?.price || classified.properties?.price_type || classified.properties?.newly_renovated) && <div className="listing-features-row">
          <div className="listing-features-price">
            {/* convert the priice to 100,000.00 */}
            {classified.properties?.price && `$${classified.properties?.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }`}
            {classified.properties?.price_type && (
              <span>
                / {classified.properties.price_type.substring(3).toLowerCase()}
              </span>
            )}
          </div>
          {classified.properties?.newly_renovated && (
            <div className="features-chip">NEWLY RENOVATED</div>
          )}
          <div className="share-button mobile" onClick={() => {
            if (navigator.share) {
              navigator.share({
                title: classified?.title ?? "",
                text: 'Check out this listing',
                url: window.location.href,
              }).then(() => {
                console.log('Thanks for sharing!');
              })
                .catch(err => {
                  console.log(`Couldn't share because of`, err.message);
                });
            } else {
              console.log('web share not supported');
            }
          }}>
            <ShareIcon size={19} fill={"var(--red)"} />
            Share
          </div>
        </div>}
        {classified.facilities.length > 0 && (
          <div className="listing-features-info">
            {classified.facilities.map(({ facility, quantity }) => {
              console.log(facility, quantity);
              if (quantity == 0) return;
              if (facility.name.includes("Bed")) {
                return (
                  <div className="listing-features-info-row">
                    <BedIcon size={20} />
                    {quantity} {facility.name}
                  </div>
                );
              }
              return (
                <div className="listing-features-info-row">
                  <ShowerIcon size={20} />
                  {quantity} {facility.name}
                </div>
              );
            })}
          </div>
        )}
        <div className="listing-features">
          {classified?.properties?.location_sqft && <div className="feature">
            <img src={Area} alt="area" />
            <div className="feature-text">
              {classified?.properties?.location_sqft} Sqft
            </div>
          </div>}
          {classified.amenities.filter(
            ({ amenity }) => amenity.type === "primary"
          ).length > 0 &&
            classified.amenities
              .filter(({ amenity }) => amenity.type === "primary")
              .map(({ amenity }, i) => {
                return (
                  <div className="feature" key={i}>
                    <img
                      src={require("../../images/" + amenity.icon)}
                      alt={amenity.name}
                    />
                    <div className="feature-text">{amenity.name}</div>
                  </div>
                );
              })
          }
        </div>
        {classified.amenities.filter(
          ({ amenity }) => amenity.type === "secondary"
        ).length > 0 && (
            <div className="listing-features tile">
              {classified.amenities
                .filter(({ amenity }) => amenity.type === "secondary")
                .map(({ amenity }, i) => {
                  return (
                    <div className="feature horizontal" key={i}>
                      <img
                        src={require("../../images/" + amenity.icon)}
                        alt={amenity.name}
                      />
                      <div className="feature-text">{amenity.name}</div>
                    </div>
                  );
                })}
            </div>
          )}
      </div>}
      {(classified.category_id !== 5 && classified.properties?.city) && <div className="location-container">
        <LocationIcon size={45} />
        <div className="location-text">
          {classified.properties?.city === "Crown Heights" ? (
            <div className="location-title">
              {(classified?.properties?.address_fields?.cross_street1 && classified?.properties?.address_fields?.cross_street2 && classified?.properties?.address_fields?.cross_street3) ? `${classified.properties?.address_fields?.cross_street1} between ${classified.properties?.address_fields?.cross_street2} and ${classified.properties?.address_fields?.cross_street3}` : classified.properties.city}
            </div>
          ) : (
            <div className="location-title">
              {classified.properties?.city}
            </div>
          )}
          {classified.properties?.city && (
            <div className="location-subtitle">
              {classified.properties?.city === "Crown Heights" ? "Brooklyn, New York" : (classified.properties?.address_fields?.city && classified.properties?.address_fields?.state) && `${classified.properties?.address_fields?.city}, ${classified.properties?.address_fields?.state}`}
            </div>
          )}
        </div>
      </div>}
      {classified.description && (
        <div className="description-section">
          <div className="description-title">Description:</div>
          <div
            dangerouslySetInnerHTML={{
              __html: classified.description,
            }}
            className="description"
          ></div>
        </div>
      )}
      <div className="listed-by-section">
        <div className="listed-by-title">Listed by:</div>
        <div className="contact-info">
          {classified.email && (
            <NavLink
              to={`mailto:${classified.email}`}
              className="contact-info-row"
            >
              <EmailIcon size={30} />
              <div>{classified.email}</div>
            </NavLink>
          )}
          {classified.phone && (
            <NavLink
              to={`tel:${classified.phone}`}
              className="contact-info-row"
            >
              <PhoneIcon size={30} fill={"#0000FF"} />
              <div>{formatPhoneNumber(classified.phone)}</div>
            </NavLink>
          )}
          {classified.whatsapp && (
            <NavLink
              to={`tel:${classified.whatsapp}`}
              className="contact-info-row"
            >
              <WhatsappIcon size={30} />
              <div>{formatPhoneNumber(classified.whatsapp)}</div>
            </NavLink>
          )}
        </div>
      </div>
      {classified.whatsapp && <a href={"https://api.whatsapp.com/send?phone=" + classified.whatsapp} className="floating-button">
        <WhatsappIcon size={40} />
      </a>}
      <span
        className="text-medium flex-row"
        style={{
          alignItems: "center",
          marginBottom: "10px",
        }}
      >
        <span className="bold">Similar Listings</span>
      </span>
      <div style={{ display: "flex", gap: "20px", overflow: "auto", width: "100%", padding: "10px", marginBottom: "20px" }}>
        {
          classified.categories.similars.map((classified, i) => {
            return (
              <ListingTile
              key={i}
                type={classified.featured ? "featured" : ""}
                images={classified.properties?.images}
                title={classified.title}
                price={classified?.properties?.price}
                facilities={classified.facilities}
                sqft={classified?.properties?.location_sqft}
                id={classified.id}
                rate={classified?.properties?.price_type}
                onIntersection={(event, unobserve) => {
                  if (event.isIntersecting) {
                    viewImpressionClassified(classified.id);
                    unobserve();
                  }
                }} />
              )
          })
        }
      </div>
    </div>
  );
};

export default ListingDetailPage;
